import useTheme from './useTheme';

export const useInvertedColor = (fields) => {
  const { isLight } = useTheme();

  const isInvertedLight = fields.InvertColourLight?.value;
  const isInvertedDark = fields.InvertColourDark?.value;

  if (isLight) {
    return isInvertedLight;
  }

  return isInvertedDark;
};
